<template>
    <div class="flex mb-px draggable relative">
        <!-- PO Item. -->
        <div class="flex flex-col flex-1 m-0 relative">
            <div class="flex flex-1 m-0 relative">
                <purchase-order-resolve-p-o-to-r-f-ms-item-select :rfms="rfms"
                                                                  :purchase-order-item="purchaseOrderItem"
                                                                  :resolve="resolve"
                                                                  ref="rfmItemSelect"
                                                                  #default="{ close, open, query, setQuery }"
                                                                  class="flex flex-1 m-0 -ml-px -mt-px -mr-px -mb-px bg-white border-l border-t border-b border-gray-200 shadow-none min-w-24">
                    <page-cell
                        class="text-sm -my-px -ml-px px-1 py-1.5 border border-gray-200"
                        placeholder="Search for RFM Item..."
                        ref="rfmItem"
                        v-if="searching"
                        v-model="search"
                        @input="searching = true;setQuery(search)"
                        @focus="searching = true;setQuery(search);open(true)"
                        @blur="applyItem(close)"
                    ></page-cell>
                    <template v-else-if="resolve.rfm">
                        <div @click="editMe()" class="text-xs pl-2 pt-0 text-gray-500"
                             v-text="findRfmText()">
                        </div>
                        <div @click="editMe()" class="text-xs pl-4 pt-0 text-gray-500"
                             v-text="findItemText()">
                        </div>
                    </template>
                    <div v-else class="text-xs pl-2 pt-2 pb-2 text-red-500" @click="editMe()" v-text="'< Please select an RFM >'"></div>
                </purchase-order-resolve-p-o-to-r-f-ms-item-select>
                <div class="w-28 -ml-px flex">
                    <page-cell
                        class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                        placeholder="Qty..."
                        ref="quantity"
                        v-model="resolve.quantity"
                        @input="updateQuantity(false)"
                        @blur="updateQuantity(true)"
                    ></page-cell>
                </div>
            </div>
        </div>
        <div class="w-6 flex-shrink-0 bg-white border-t -mt-px border-gray-200">
            <ui-dropdown menu-class="p-3 w-72">
                <template #default="{ toggle }">
                    <button @click="toggle"
                            class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded mt-1.5">
                        <i class="fa fa-ellipsis-h fa-fw pl-1 pr-1"></i>
                    </button>
                </template>
                <template #menu="{ close }">
                    <template>
                        <ui-dropdown-item icon="fas fa-trash" danger
                                          @click="$emit('removeItem',resolve);close();">
                            Remove Resolution
                        </ui-dropdown-item>
                    </template>
                </template>
            </ui-dropdown>
        </div>
    </div>
</template>

<script>

import PageCell from "../../ui/PageCell.vue";
import moment from "moment";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import PurchaseOrderResolvePOToRFMsItemSelect from "./PurchaseOrderResolvePOToRFMsItemSelect.vue";

export default {
    components: {
        PurchaseOrderResolvePOToRFMsItemSelect,
        UiDropdownItem,
        UiDropdown,
        PageCell
    },
    props: {
        resolve: Object,
        rfms: Array,
        purchaseOrderItem: Object,
    },
    data() {
        return {
            search: "",
            searching: false,
            moment: moment,
        }
    },
    watch: {},
    computed: {},
    methods: {
        findRfmText() {
            if (this.resolve.rfm) {
                let rfm = this.rfms.find((i) => i.id === this.resolve.rfm.id);
                if (rfm) {
                    return 'RFM #' + rfm.reference
                }
            }
            return 'Unknown RFM - maybe deleted?';
        },
        findItemText() {
            if (this.resolve.rfm) {
                let rfm = this.rfms.find((i) => i.id === this.resolve.rfm.id);
                if (rfm) {
                    let item = rfm.items.find((i) => i.id === this.resolve.rfm.item.id);
                    if (item) {
                        return item.material + ' (' + item.unitOfMeasure + ' ' + item.required + ')'
                    }
                }
            }
            return 'Unknown RFM item - maybe deleted?';
        },
        updateQuantity(finished) {
        },
        applyItem(close) {
            this.searching = false;
            close();
        },

        editMe() {
            this.searching = true;
            this.$nextTick(() => this.$refs.rfmItem.focusAsNew())
        },
    },
    mounted() {
    }
}
</script>